import { Link } from "react-router-dom";
import { LuHeartHandshake, LuArrowRight } from "react-icons/lu";
import "../../styles/partners/partners.css"
import { PRIVATE_PARTNERS, PUBLIC_PARTNERS, SPORT_PARTNERS } from "../../utils/partners";


const PARTNER_GROUPS = [
  { id: "private", title: "Nos partenaires privés", partners: PRIVATE_PARTNERS },
  { id: "public", title: "Nos partenaires institutionnels", partners: PUBLIC_PARTNERS },
  { id: "sport", title: "Nos partenaires sportifs", partners: SPORT_PARTNERS },
];


function Partners() {

  return (
    <main className="partners">

      {/* EN-TÊTE */}
      <header className="page-hero">
        <div className="wrap page-hero_content">
          <p className="page-hero_eyebrow">
            <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
            Partenaires
          </p>
          <h1 className="page-hero_title">Ils nous soutiennent</h1>
          <p className="page-hero_text">Entreprises, collectivités et instances du volley : merci à tous ceux qui font vivre le club.</p>
        </div>
      </header>

      {/* DEVENIR PARTENAIRE */}
      <div className="wrap">
        <section className="become_partner surface" aria-labelledby="become-partner-title">
          <span className="icon-tile icon-tile--red" aria-hidden="true"><LuHeartHandshake /></span>
          <div className="become_partner_text">
            <h2 id="become-partner-title" className="title-lg">Devenez partenaire du VBLC</h2>
            <p>Avec ses 140 adhérents sportifs et l’organisation de ses 4 tournois par an, dont le tournoi de beach des Fêtes de Saint-Jean-de-Luz, le VBLC fait partie des clubs de volley-ball les plus dynamiques du Pays basque.</p>
            <p>Être partenaire du club ou sponsor de l’un de ses évènements, c’est l’assurance de donner encore plus de visibilité à votre marque ou à votre établissement.</p>
          </div>
          <Link to="/contact" className="btn btn--primary btn--lg become_partner_button">
            Contactez-nous <LuArrowRight aria-hidden="true" />
          </Link>
        </section>
      </div>

      {/* LOGOS PAR CATÉGORIE */}
      {PARTNER_GROUPS.map((group, index) => (
        <section key={group.id} className={`section ${index % 2 === 0 ? "" : "section--white"} partners_section`} aria-labelledby={`${group.id}-title`}>
          <div className="wrap">
            <h2 id={`${group.id}-title`} className="title-xl partners_title">{group.title}</h2>
            <ul className="partners_grid partners_grid--centered">
              {group.partners.map((p) => (
                <li key={p.partner}>
                  <a className="partner_tile" href={p.webLink} target="_blank" rel="noreferrer">
                    <img src={p.logoUrl} alt={p.partner} />
                    <span className="sr-only">(nouvel onglet)</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}
    </main>
  )
};

export default Partners;
